export const SettingsHeader = () => {
  return (
    <>
      <div className="text-2xl font-bold leading-9" aria-label="Settings">
        Settings
      </div>
      <div className="text-muted-foreground" aria-label="Manage your account settings">
        Manage your account settings
      </div>
      <div className="mt-6 h-[1px] w-full bg-border" aria-hidden />
    </>
  )
}
